var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chunk-error",attrs:{"role":"alert"}},[_c('p',{staticClass:"chunk-error__text"},[_vm._v(_vm._s(_vm.$t('chunkLoadFailed')))]),_vm._v(" "),_c('button',{staticClass:"chunk-error__button",attrs:{"type":"button"},on:{"click":_vm.reload}},[_vm._v("\n        "+_vm._s(_vm.$t('chunkLoadRetry'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }